let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ctqAV")).then(() => parcelRequire('6B9u2'));